import { render, staticRenderFns } from "./MedOcuFamiliar.vue?vue&type=template&id=317c29be&scoped=true"
import script from "./MedOcuFamiliar.vue?vue&type=script&lang=js"
export * from "./MedOcuFamiliar.vue?vue&type=script&lang=js"
import style0 from "./MedOcuFamiliar.vue?vue&type=style&index=0&id=317c29be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c29be",
  null
  
)

export default component.exports